<template lang="pug">
.c-pagination-loader
  b-pagination(:total="total"
    :current="_page"
    :per-page="perPage"
    order="is-centered"
    @change="$emit('update:page', $event)")
</template>

<script>
export default {
  name: "PaginationLoader",
  props: {
    counterRef: {
      type: Object,
      required: true
    },
    counterKey: {
      type: String,
      required: true
    },
    queryRef: {
      type: Object,
      required: true
    },
    perPage: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    },
    page: {
      type: [Number, String],
      default: 1
    },
    length: {
      type: Number,
      required: true
    },
    lastDoc: {
      type: Object,
      default: null
    }
  },
  computed: {
    _page() {
      return Number(this.page);
    }
  },
  watch: {
    _page: {
      async handler(n) {
        if (!Number.isInteger(n)) return;
        await this.fetchData();
      },
      immediate: true
    }
  },
  methods: {
    async fetchTotal() {
      const counts = await this.counterRef.get();
      const total = counts.data()[this.counterKey];
      this.$emit("update:total", total);
    },
    async fetchData() {
      await this.$nextTick();
      if (!this.total) await this.fetchTotal();

      const nums = this._page * this.perPage;
      if (nums <= this.length || this.length >= this.total) {
        return;
      }

      const range = nums - this.length;
      let snap;

      if (this.lastDoc) {
        snap = await this.queryRef
          .startAfter(this.lastDoc)
          .limit(range)
          .get();
      } else {
        snap = await this.queryRef.limit(range).get();
      }

      const items = this.$u.parseDbSnap(snap);
      this.$emit("update:items", items);

      // set last doc
      const lastDoc = snap.docs[snap.docs.length - 1];
      this.$emit("update:lastDoc", lastDoc);
    }
    /*
    async update() {
      if (!this.total) await this.fetchTotal();

      const nums = this.currentPage * this.perPage;
      if (nums <= this.length || this.length >= this.total) {
        return this.updateCurrentItems();
      };
      
      const range = nums - this.length;
      let snap;

      if (this.lastDoc) {
       snap = await this.queryRef.startAfter(this.lastDoc).limit(range).get()
      } else {
        snap = await this.queryRef.limit(range).get()
      }

      // set last doc
      this.lastDoc = snap.docs[snap.docs.length - 1];

      return this.$u.parseDbSnap(snap);
    },
    */
    /*
    updateCurrentItems() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      this.currentItems = this.items.slice(start, end);
      return this.$emit("update", this.currentItems);
    },
    */
  }
};
</script>
